import React from 'react'
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { t } from 'i18next';
export default function HeaderCard(props) {
    return (
        <div className='d-md-flex align-items-center justify-content-between'>
            <h5 className='h5 fw-bold'>{props.title}</h5>
            <Breadcrumb className='d-none d-sm-block'>
                <Breadcrumb.Item active><i class="ti ti-home"></i> {t("label.general.navigation.home")}</Breadcrumb.Item>
            </Breadcrumb>
        </div>
    )
}
